<!-- 溯源码信息 预览溯源码 -->
<template>
    <div class="container">
        <div class="header">
            <Input
                class="mr24 mb24 w200"
                type="text"
                v-model="storePrams.qrcode_number"
                placeholder="通过溯源码查询"
            ></Input>
            <Input
                class="mr24 mb24 w200"
                type="text"
                v-model="storePrams.delivery_qrcode"
                placeholder="通过发货码查询"
            ></Input>
            <Select
                class="mr24 mb24 w200"
                v-model="storePrams.batch_id"
                clearable
                filterable
                placeholder="通过关联批次查询"
            >
                <Option
                    v-for="item in batchList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.batch_name }}</Option
                >
            </Select>
            <Select
                class="mr24 mb24 w200"
                v-model="storePrams.product_id"
                clearable
                filterable
                placeholder="通过关联产品查询"
            >
                <Option
                    v-for="item in productList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.product_name }}</Option
                >
            </Select>
            <Select
                class="mr24 mb24 w200"
                v-model="storePrams.status"
                clearable
                filterable
                placeholder="状态查询"
            >
                <Option
                    v-for="item in statusList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                >
            </Select>
            <DatePicker
                class="mr24 mb24 width_15"
                type="daterange"
                v-model="dates"
                split-panels
                placement="bottom-start"
                placeholder="选择日期"
                separator=" 至 "
                @on-change="changeDate"
            ></DatePicker>
            <Button
                class="theme-bc mb24 mr24 theme-default-color"
                icon="ios-search"
                @click="goSearch"
                >确认搜索</Button
            >
            <Button class="mb24" icon="md-refresh" @click="goClear"
                >清空条件</Button
            >
        </div>
        <div class="content">
            <div>
                <Button class="mb24 mr24" @click="goExport">批量导出</Button>
                <Button class="mb24 mr24" @click="goDrawer">导出记录</Button>
                <Button class="mb24 mr24" @click="goImportCode"
                    >导入码</Button
                >
                <Table
                    :loading="loading"
                    :columns="columnsTable"
                    :data="dataTable"
                    border
                >
                    <template slot-scope="{ row }" slot="product_name">
                        <div>
                            <div>
                                商品:{{
                                    row.product ? row.product.product_name : ""
                                }}
                            </div>
                            <div>
                                批次:{{ row.batch ? row.batch.batch_name : "" }}
                            </div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="agent_name">
                        <div>{{ row.agent ? row.agent.agent_name : "" }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="qrcode_count">
                        <div class="flex-c">
                            <Tooltip
                                v-if="
                                    row.qrcode_log.some(
                                        (item) => item.status == 2
                                    )
                                "
                                max-width="250"
                                placement="top"
                                theme="light"
                                transfer
                            >
                                <Icon
                                    class="cursor-p mr12"
                                    type="md-help-circle"
                                    size="20"
                                    color="#FF4838"
                                />
                                <div slot="content">
                                    <p>
                                        失败原因：{{ row.qrcode_log[0].msg }}
                                    </p>
                                </div>
                            </Tooltip>
                            <span
                                :style="
                                    row.qrcode_log.some(
                                        (item) => item.status == 2
                                    )
                                        ? ''
                                        : 'color: #53C41A;'
                                "
                            >
                                {{
                                    row.qrcode_log.reduce((sum, item) => {
                                        if (item.status === 1) {
                                            return sum + item.qrcode_num;
                                        }
                                        return sum;
                                    }, 0)
                                }}
                            </span>
                            <span style="color: #53c41a"
                                >/{{ row.qrcode_count }}</span
                            >
                            <!-- <Icon
                                class="cursor-p ml12"
                                v-if="
                                    row.qrcode_log.some(
                                        (item) => item.status == 2
                                    )
                                "
                                type="md-refresh-circle"
                                size="20"
                                color="#2DC0F7"
                                @click="goRefresh(row)"
                            /> -->
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div v-if="row.status == 1" style="color: #53c41a">
                            <Icon
                                type="ios-checkmark-circle-outline"
                                color="#53C41A"
                            />启用
                        </div>
                        <div v-if="row.status == 2" style="color: #ff4838">
                            <Icon
                                type="ios-close-circle-outline"
                                color="#FF4838"
                            />未启用
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="success" ghost @click="goManage(row)"
                                >预览</Button
                            >
                            <Button
                                type="primary"
                                ghost
                                @click="goModal(1, row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(1, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <!-- 预览（溯源码管理） -->
        <Drawer v-model="manageDrawer" title="溯源码管理" width="80">
            <div>
                <div class="flex">
                    <Input
                        class="mr24 w200 mb24"
                        type="text"
                        v-model="pageQrcode.qrcode_number"
                        placeholder="请输入溯源码查询"
                    ></Input>
                    <Input
                        class="mr24 w200 mb24"
                        type="text"
                        v-model="pageQrcode.delivery_qrcode"
                        placeholder="请输入发货码查询"
                    ></Input>
                    <Select
                        class="mr24 w200 mb24"
                        v-model="pageQrcode.status"
                        clearable
                        filterable
                        placeholder="状态查询"
                    >
                        <Option
                            v-for="item in statusList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.name }}</Option
                        >
                    </Select>
                    <DatePicker
                        class="mr24 w200 mb24"
                        type="daterange"
                        split-panels
                        placement="bottom-start"
                        placeholder="选择时间段"
                        separator=" 至 "
                        @on-change="changeQrcodeDate"
                    ></DatePicker>
                    <Button
                        class="theme-bc theme-default-color"
                        icon="ios-search"
                        @click="goSearchQrcode"
                        >确认搜索</Button
                    >
                </div>
                <Table :columns="columnQrcode" :data="dataQrcode" border>
                    
                    <template slot-scope="{ row }" slot="product_name">
                        <div>
                            <div>
                                产品:{{
                                    row.product ? row.product.product_name : ""
                                }}
                            </div>
                            <div>
                                批次:{{ row.batch ? row.batch.batch_name : "" }}
                            </div>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div v-if="row.status == 1" style="color: #53c41a">
                            <Icon
                                type="ios-checkmark-circle-outline"
                                color="#53C41A"
                            />启用
                        </div>
                        <div v-if="row.status == 2" style="color: #ff4838">
                            <Icon
                                type="ios-close-circle-outline"
                                color="#FF4838"
                            />未启用
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button
                                v-if="row.after"
                                type="success"
                                ghost
                                @click="goAfterSalesInfo(row)"
                                >售后信息</Button
                            >
                            <Button
                                type="success"
                                ghost
                                @click="goPreview(row)"
                                >预览</Button
                            >
                            <Button
                                type="primary"
                                ghost
                                @click="goModal(2, row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(2, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="page">
                    <Page
                        :current="pageQrcode.page"
                        :page-size="pageQrcode.limit"
                        :total="totalQrcode"
                        show-elevator
                        show-total
                        @on-change="pageChangeQrcode"
                    />
                </div>
            </div>
        </Drawer>
        <!-- 导出记录 -->
        <Drawer v-model="infoDrawer" title="导出记录" width="80">
            <div>
                <Table :columns="columnExport" :data="dataExport" border>
                    <template slot-scope="{ row }" slot="batch_name">
                        <div v-if="row.batch[0]">
                            {{ row.batch[0].batch_name }}
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="export_type_name">
                        <div>{{ row.export_type_name }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <div
                            v-if="row.log.every((item) => item.status == 1)"
                            style="color: #53c41a"
                        >
                            <Icon
                                type="ios-checkmark-circle-outline"
                                color="#53C41A"
                            />导出成功
                        </div>
                        <div v-else>
                            <div
                                v-if="row.log.some((item) => item.status == 2)"
                                style="color: #ff4838"
                            >
                                <Icon
                                    type="ios-close-circle-outline"
                                    color="#FF4838"
                                />导出失败
                            </div>
                            <template v-else>
                                <div
                                    v-if="
                                        row.log.some((item) => item.status == 0)
                                    "
                                    class="flex-c"
                                >
                                    <img
                                        class="width_height_18"
                                        src="../../assets/loading.gif"
                                    />
                                    <span style="color: var(--primary-color)">正在导出</span>
                                </div>
                            </template>
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button
                                v-if="row.log.every((item) => item.status == 1)"
                                type="primary"
                                ghost
                                @click="goDownload(row)"
                                >下载</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="page">
                    <Page
                        :current="pageExport.page"
                        :page-size="pageExport.limit"
                        :total="totalExport"
                        show-elevator
                        show-total
                        @on-change="pageChangeExport"
                    />
                </div>
            </div>
        </Drawer>
        <!-- 预览 -->
        <Modal
            v-model="previewModal"
            title="预览"
            width="30"
            :mask-closable="false"
        >
            <div class="flex-c flex-column">
                <div>
                    查看编码为【{{ itemData.qrcode_number }}】的溯源码效果
                </div>
                <div class="width_height_200">
                    <VueQr
                        class="width_height_100"
                        id="vueQr"
                        :text="itemData.qrcode_url"
                    ></VueQr>
                </div>
                <div>扫码浏览模板</div>
                <div>支持任意扫码工具扫码查询</div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 批量导出 -->
        <Modal
            v-model="exportModal"
            title="批量导出"
            width="500"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formExport"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="选择产品：">
                        <Select
                            v-model="formExport.product_id"
                            clearable
                            filterable
                            placeholder="请选择产品"
                        >
                            <Option
                                v-for="item in productList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.product_name }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="选择批次：">
                        <Select
                            v-model="formExport.batch_id"
                            clearable
                            filterable
                            placeholder="请选择批次"
                        >
                            <Option
                                v-for="item in batchList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.batch_name }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="选择导入项：">
                        <CheckboxGroup v-model="itemData.exportValue">
                            <Checkbox label="关联批次" border></Checkbox>
                            <Checkbox label="关联产品" border></Checkbox>
                        </CheckboxGroup>
                    </FormItem>
                    <FormItem label="选择格式：">
                        <Select
                            class="w200"
                            v-model="formExport.export_type"
                            clearable
                            filterable
                            placeholder="请选择格式"
                        >
                            <Option
                                v-for="item in exportTypeList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.name }}</Option
                            >
                        </Select>
                        <Tooltip
                            max-width="250"
                            placement="bottom"
                            theme="light"
                        >
                            <Icon
                                class="cursor-p ml24"
                                type="md-help-circle"
                                size="20"
                                color="#FF4838"
                            />
                            <div slot="content">
                                <p>导出印刷重要说明提示:</p>
                                <p>
                                    1、当溯源码编码为纯数字,且超15位时,用EXCLE打开,会以科学计数法显示,导致编码出错。如果存在该情况,建议导出为TXT格式。
                                </p>
                                <p>
                                    2、正式批量印刷前,请先印几张用于测试,以免错误。
                                </p>
                                <p>
                                    3、导出成功,为了数据安全,只做临时存储请点击<span
                                        class="theme-color"
                                        >“导出记录”</span
                                    >下载数据包到本地点击下载数据包到本地。
                                </p>
                            </div>
                        </Tooltip>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelExportModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    :disabled="!isClickable"
                    @click="submitExportModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 溯源码编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            :width="modalWidth"
            :mask-closable="false"
        >
            <Form :model="formData" label-position="right" :label-width="150">
                <FormItem label="选择关联批次：">
                    <Select
                        class="w200"
                        v-model="formData.batch_id"
                        clearable
                        filterable
                        placeholder="请选择关联批次"
                    >
                        <Option
                            v-for="item in batchList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.batch_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p>选择批次,没有请先在【批次管理】中【新增批次】</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="选择关联产品：">
                    <Select
                        class="w200"
                        v-model="formData.product_id"
                        clearable
                        filterable
                        placeholder="请选择关联产品"
                    >
                        <Option
                            v-for="item in productList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.product_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p>选择关联的产品,生成后可批量修改更换</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="选择所属经销商：">
                    <Select
                        class="w200"
                        v-model="formData.agent_id"
                        clearable
                        filterable
                        placeholder="请选择所属经销商"
                    >
                        <Option
                            v-for="item in agentList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.agent_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p>选择默认所属的经销商，不选则暂时为空</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="质保期：">
                    <Input
                        class="w200"
                        type="text"
                        v-model="formData.warranty_days"
                        placeholder="请输入质保期"
                        ><span slot="append">天</span></Input
                    >
                </FormItem>
                <FormItem label="生产时间：">
                    <DatePicker
                        class="w200"
                        :value="formData.productive_time"
                        type="date"
                        placeholder="点击选择时间"
                        @on-change="changeProductiveTime"
                    ></DatePicker>
                </FormItem>
                <FormItem label="过期时间：">
                    <DatePicker
                        class="w200"
                        :value="formData.expiration_date"
                        type="date"
                        placeholder="点击选择时间"
                        @on-change="changeExpirationDate"
                    ></DatePicker>
                </FormItem>
                <FormItem label="是否启用：">
                    <i-switch
                        v-model="formData.status"
                        size="large"
                        true-color="var(--primary-color) "
                        :true-value="1"
                        :false-value="2"
                    >
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <FormItem v-if="modalID == 1" label="是否启用密码: ">
                    <i-switch
                        v-model="formData.able_key"
                        size="large"
                        true-color="var(--primary-color) "
                        :true-value="1"
                        :false-value="0"
                    >
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <FormItem
                    v-if="modalID == 1 && formData.able_key"
                    label="密码: "
                >
                    <Input
                        class="w200"
                        password
                        type="password"
                        v-model="formData.qrcode_key"
                        placeholder="请输入密码"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 导入码 -->
        <Modal
            v-model="importCodeModal"
            title="导入码"
            width="500"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formImportCode"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="选择批次：">
                        <Select
                            v-model="formImportCode.batch_id"
                            clearable
                            filterable
                            placeholder="请选择批次"
                        >
                            <Option
                                v-for="item in batchList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.batch_name }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="选择产品：">
                        <Select
                            v-model="formImportCode.product_id"
                            clearable
                            filterable
                            placeholder="请选择产品"
                        >
                            <Option
                                v-for="item in productList"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.product_name }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem label="上传文件：">
                        <div style="display: flex">
                            <Upload
                                ref="upload"
                                :show-upload-list="false"
                                :format="['xlsx']"
                                :max-size="5120"
                                :on-exceeded-size="exceededSize"
                                :on-format-error="handleFormatError"
                                :on-success="keySuccess"
                                :on-progress="handleProgress"
                                :headers="headers"
                                :action="uploadImg"
                            >
                                <Button>{{
                                    formImportCode.file
                                        ? "已成功上传"
                                        : "点击上传"
                                }}</Button>
                            </Upload>
                            <Tooltip
                                max-width="250"
                                placement="right"
                                theme="light"
                            >
                                <Icon
                                    class="cursor-p ml24"
                                    type="md-help-circle"
                                    size="20"
                                    color="#FF4838"
                                />
                                <div slot="content">
                                    <p>
                                        只支持xlsx文件，数据较多需耐心等待处理
                                    </p>
                                </div>
                            </Tooltip>
                        </div>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelImportCodeModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitImportCodeModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 售后信息编辑 -->
        <Modal
            v-model="productModal"
            title="售后信息编辑"
            width="600"
            :mask-closable="false"
        >
            <Form
                :model="formProduct"
                label-position="right"
                :label-width="150"
            >
                <div class="product-title">基础信息</div>
                <FormItem label="激活日期">
                    <DatePicker
                        class="w300"
                        :value="formProduct.active_date"
                        type="date"
                        placeholder="点击选择时间"
                        @on-change="changeActiveDate"
                    ></DatePicker>
                </FormItem>
                <FormItem label="质保期">
                    <Input
                        class="w300"
                        type="text"
                        v-model="formProduct.days"
                        placeholder="请输入质保期"
                        ><span slot="append">天</span></Input
                    >
                </FormItem>
                <template v-if="formProduct.json_text.length">
                    <div class="product-title">填写信息</div>
                    <FormItem
                        v-for="(item, index) in formProduct.json_text"
                        :key="index"
                        :label="item.title_name"
                    >
                        <Input
                            v-if="item.type == 1"
                            v-model="item.input_value"
                            type="text"
                            :placeholder="item.prompt_text"
                        ></Input>
                        <CheckboxGroup
                            v-if="item.type == 2"
                            v-model="item.input_value"
                        >
                            <template v-if="item.type_val">
                                <Checkbox
                                    v-for="(e, i) in item.type_val.split('*')"
                                    :key="i"
                                    :label="e"
                                ></Checkbox>
                            </template>
                        </CheckboxGroup>
                        <Input
                            v-if="item.type == 3"
                            type="textarea"
                            v-model="item.input_value"
                            :placeholder="item.prompt_text"
                        ></Input>
                        <RadioGroup
                            v-if="item.type == 4"
                            v-model="item.input_value"
                        >
                            <template v-if="item.type_val">
                                <Radio
                                    v-for="(e, i) in item.type_val.split('*')"
                                    :key="i"
                                    :label="e"
                                ></Radio>
                            </template>
                        </RadioGroup>
                        <Select
                            v-if="item.type == 5"
                            :placeholder="item.prompt_text"
                            v-model="item.input_value"
                            clearable
                        >
                            <template v-if="item.type_val">
                                <Option
                                    v-for="(e, i) in item.type_val.split('*')"
                                    :value="e"
                                    :key="i"
                                    >{{ e }}</Option
                                >
                            </template>
                        </Select>
                        <DatePicker
                            v-if="item.type == 6"
                            type="date"
                            :value="item.input_value"
                            :placeholder="item.prompt_text"
                            style="width: 100%"
                        ></DatePicker>
                        <div v-if="item.type == 7" class="img-divs">
                            <div
                                class="img-div"
                                @click="openModal(item, 'img')"
                            >
                                <img
                                    src="@/assets/img.png"
                                    alt=""
                                    class="img-div-icon"
                                />
                            </div>
                            <div v-for="(e, i) in item.show_upload" :key="i">
                                <div class="upload-div">
                                    <Icon
                                        class="upload-del"
                                        size="20"
                                        type="ios-close-circle"
                                        color="#f00"
                                        @click="delImg(item, i)"
                                    />
                                    <img class="upload-img" :src="e" />
                                </div>
                            </div>
                            <div class="img-txt">最多上传10张</div>
                        </div>
                        <div v-if="item.type == 8" class="img-divs">
                            <div
                                class="img-div"
                                @click="openModal(item, 'video')"
                            >
                                <img
                                    src="@/assets/video.png"
                                    alt=""
                                    class="img-div-icon"
                                />
                            </div>
                            <div v-if="item.show_upload" class="upload-div">
                                <Icon
                                    class="upload-del"
                                    size="20"
                                    type="ios-close-circle"
                                    color="#f00"
                                    @click="delVideo(item)"
                                />
                                <video
                                    class="upload-img"
                                    :src="item.show_upload"
                                ></video>
                            </div>
                            <div class="img-txt">最大上传50MB视频</div>
                        </div>
                    </FormItem>
                </template>
            </Form>
            <div slot="footer">
                <Button @click="cancelProductModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitProductModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import {
    qrcode_count_list,
    qrcode_count_delete,
    qrcode_count_refresh,
    qrcode_count_edit,
    qrcode_count_info,
    qrcode_list,
    qrcode_info,
    qrcode_edit,
    qrcode_delete,
    export_list,
    export_qrcode,
    other_special_import,
    customer_sales_info,
    customer_sales_save,
    get_options,
} from "@/api/index";
import VueQr from "vue-qr";
import config from "@/config/index";
import { getCookies, getStorages } from "@/utils/helper";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: { VueQr, pictureLibrary },
    props: {
        codeData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select_value: "",
            select_data: "",
            select: 1,
            select_type: "image",
            switch_modal: false,
            uploadImg: config.apiUrl + "/api/other/upload",
            headers: { "hlzw-suyuan-token": getCookies("p_c_access_token") },
            dates: "",
            storePrams: {
                page: 1,
                limit: 10,
                product_id: "",
                batch_id: "",
                status: "",
                start_date: "",
                end_date: "",
                qrcode_number: "",
                delivery_qrcode: "",
            },
            total: 0,
            columnsTable: [
                { type: "selection", width: 60, align: "center" },
                { title: "ID", key: "id", align: "center" },
                { title: "关联信息", slot: "product_name", align: "center" },
                { title: "经销商", slot: "agent_name", align: "center" },
                { title: "生成时间", key: "created_at", align: "center" },
                {
                    title: "生成状态",
                    slot: "qrcode_count",
                    align: "center",
                    width: "200px",
                },
                { title: "码状态", slot: "status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "300px",
                },
            ],
            dataTable: [],
            itemData: {
                count_id: "",
                qrcode_url: "",
                qrcode_number: "",
                prefix1: "",
                prefix2: "",
                prefix3: "",
                prefix4: "",
                id: "",
                exportValue: [],
            },
            formData: {
                batch_id: "",
                product_id: "",
                agent_id: "",
                status: 2,
                qrcode_count: "",
                qrcode_length: "",
                qrcode_prefix: "",
                qrcode_type: "",
                productive_time: "",
                warranty_days: "",
                expiration_date: "",
                type: "",
                able_key: 0,
                qrcode_key: "",
            },
            batchList: [],
            productList: [],
            agentList: [],
            statusList: [
                { id: 1, name: "开启" },
                { id: 2, name: "关闭" },
            ],
            previewModal: false,
            exportModal: false,
            modals: false,
            modalTitle: "",
            modalID: 1,
            modalWidth: "",
            manageDrawer: false,
            infoDrawer: false,
            pageQrcode: {
                start_date: "",
                end_date: "",
                qrcode_number: "",
                limit: 10,
                page: 1,
                status: "",
                count_id: "",
                delivery_qrcode: "",
            },
            totalQrcode: 0,
            columnQrcode: [
                { title: "ID", key: "id", align: "center" },
                { title: "溯源码编码", key: "qrcode_number", align: "center" },
                { title: "发货码", key: "delivery_qrcode", align: "center" },
                { title: "关键信息", slot: "product_name", align: "center" },
                { title: "码状态", slot: "status", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "300px",
                },
            ],
            dataQrcode: [],
            formExport: {
                batch_id: "",
                is_product: 0,
                is_batch: 0,
                export_type: "",
                product_id: "",
            },
            exportTypeList: [
                { id: 1, name: "Excel电子文档格式" },
                { id: 2, name: "TXT文本格式" },
            ],
            pageExport: {
                limit: 10,
                page: 1,
            },
            totalExport: 0,
            columnExport: [
                { title: "导出批次", slot: "batch_name", align: "center" },
                { title: "导出项", key: "export_action", align: "center" },
                {
                    title: "选择格式",
                    slot: "export_type_name",
                    align: "center",
                },
                { title: "状态", slot: "status", align: "center" },
                { title: "导出时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "100px",
                },
            ],
            dataExport: [],
            isClickable: true,
            importCodeModal: false,
            formImportCode: {
                batch_id: "",
                product_id: "",
                file: "",
            },
            loading: false,
            productModal: false,
            formProduct: {
                id: "",
                active_date: "",
                days: "",
                json_text: [],
            },
            infos:getStorages('infos')
        };
    },
    created() {
    },
    mounted() {
        this.getList();
        this.getOptions();
    },
    watch: {
        // 批次管理-预览溯源码
        codeData(newVal, oldVal) {
            this.loading = true;
            this.storePrams.batch_id = newVal.id;
            qrcode_count_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    this.loading = false;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.select_value == "img") {
                for (var i = 0; i < param1.length; i++) {
                    this.select_data.show_upload.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.select_data.upload_value.push(param2[i]);
                }
            } else if (this.select_value == "video") {
                for (var i = 0; i < param1.length; i++) {
                    this.select_data.show_upload = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.select_data.upload_value = param2[i];
                }
            }
        },
        openModal(item, index) {
            this.select_data = item;
            this.select_value = index;
            if (this.select_value == "video") {
                this.select_type = "video";
            } else {
                this.select_type = "image";
                if (this.select_data.show_upload == null) {
                    this.select_data.show_upload = [];
                }
                if (this.select_data.upload_value == null) {
                    this.select_data.upload_value = [];
                }
            }
            this.switch_modal = true;
        },
        getList() {
            qrcode_count_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getQrcodeList() {
            qrcode_list(this.pageQrcode)
                .then((res) => {
                    this.dataQrcode = res.data.data;
                    this.totalQrcode = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getExportList() {
            export_list(this.pageExport)
                .then((res) => {
                    this.dataExport = res.data.data;
                    this.totalExport = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        pageChangeQrcode(index) {
            this.pageQrcode.page = index;
            this.getQrcodeList();
        },
        pageChangeExport(index) {
            this.pageExport.page = index;
            this.getExportList();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        goSearchQrcode() {
            this.pageQrcode.page = 1;
            this.getQrcodeList();
        },
        goClear() {
            this.storePrams.page = 1;
            this.storePrams.limit = 10;
            this.storePrams.product_id = "";
            this.storePrams.batch_id = "";
            this.storePrams.status = "";
            this.storePrams.start_date = "";
            this.storePrams.end_date = "";
            this.storePrams.qrcode_number = "";
            this.storePrams.delivery_qrcode = "";
            this.dates = "";
        },
        goRefresh(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "是否确认重新生成？",
                onOk: () => {
                    qrcode_count_refresh({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        // 下拉
        getOptions() {
            get_options()
                .then((res) => {
                    this.productList = res.data.product;
                    this.agentList = res.data.agent;
                    this.batchList = res.data.batch;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        changeDate(e) {
            if (e[0]) {
                this.storePrams.start_date = e[0];
                this.storePrams.end_date = e[1];
            } else {
                this.storePrams.start_date = "";
                this.storePrams.end_date = "";
            }
        },
        changeQrcodeDate(e) {
            if (e[0]) {
                this.pageQrcode.start_date = e[0];
                this.pageQrcode.end_date = e[1];
            } else {
                this.pageQrcode.start_date = "";
                this.pageQrcode.end_date = "";
            }
        },
        changeProductiveTime(e) {
            if (e) {
                this.formData.productive_time = e;
            } else {
                this.formData.productive_time = "";
            }
        },
        changeExpirationDate(e) {
            if (e) {
                this.formData.expiration_date = e;
            } else {
                this.formData.expiration_date = "";
            }
        },
        goDel(index, row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 1) {
                        qrcode_count_delete({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 2) {
                        qrcode_delete({ id: row.id })
                            .then((res) => {
                                this.getQrcodeList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        goPreview(row) {
            this.itemData.qrcode_number = row.qrcode_number;
            if (row.qrcode_url) {
                this.itemData.qrcode_url = row.qrcode_url;
            }
            this.previewModal = true;
        },
        goExport() {
            this.formExport.batch_id = "";
            this.formExport.is_product = 0;
            this.formExport.is_batch = 0;
            this.formExport.export_type = "";
            this.formExport.product_id = "";
            this.exportModal = true;
        },
        goImportCode() {
            this.formImportCode.batch_id = "";
            this.formImportCode.product_id = "";
            this.formImportCode.file = "";
            this.importCodeModal = true;
        },
        goModal(index, row) {
            this.modalID = index;
            this.modalTitle = "溯源码编辑";
            this.modalWidth = 600;
            if (index == 1) {
                qrcode_count_info({ id: row.id })
                    .then((res) => {
                        this.formData.batch_id = res.data.batch_id;
                        this.formData.product_id = res.data.product_id;
                        this.formData.agent_id = res.data.agent_id;
                        this.formData.status = res.data.status;
                        this.formData.qrcode_count = res.data.qrcode_count;
                        this.formData.qrcode_length = res.data.qrcode_length;
                        this.formData.qrcode_prefix = res.data.qrcode_prefix;
                        this.formData.qrcode_type = res.data.qrcode_type;
                        this.formData.productive_time =
                            res.data.productive_time;
                        this.formData.warranty_days = res.data.warranty_days;
                        this.formData.expiration_date =
                            res.data.expiration_date;
                        this.formData.type = res.data.type;
                        this.itemData.count_id = res.data.id;
                        this.formData.able_key = res.data.able_key;
                        this.formData.qrcode_key = res.data.qrcode_key;
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            } else if (index == 2) {
                qrcode_info({ id: row.id })
                    .then((res) => {
                        this.formData.batch_id = res.data.batch_id;
                        this.formData.product_id = res.data.product_id;
                        this.formData.agent_id = res.data.agent_id;
                        this.formData.status = res.data.status;
                        this.formData.productive_time =
                            res.data.productive_time;
                        this.formData.warranty_days = res.data.warranty_days;
                        this.formData.expiration_date =
                            res.data.expiration_date;
                        this.itemData.id = res.data.id;
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
            setTimeout(() => {
                this.modals = true;
            }, 300);
        },
        goAfterSalesInfo(row) {
            this.formProduct.id = row.after.id;
            customer_sales_info({ id: this.formProduct.id })
                .then((res) => {
                    this.formProduct.active_date = res.data.active_date;
                    this.formProduct.days = res.data.days;
                    this.formProduct.json_text = res.data.json_text;
                    setTimeout(() => {
                        this.productModal = true;
                    }, 300);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelExportModal() {
            this.exportModal = false;
        },
        submitExportModal() {
            if (this.isClickable) {
                this.isClickable = false;
                setTimeout(() => {
                    this.isClickable = true;
                }, 1000);
                this.itemData.exportValue.forEach((item) => {
                    if (item == "关联批次") {
                        this.formExport.is_batch = 1;
                    } else if (item == "关联产品") {
                        this.formExport.is_product = 1;
                    }
                });
                if (!this.formExport.batch_id) {
                    this.$Message.error("请选择批次");
                    return;
                }
                if (!this.formExport.is_batch && !this.formExport.is_product) {
                    this.$Message.error("请选择导入项");
                    return;
                }
                if (!this.formExport.export_type) {
                    this.$Message.error("请选择格式");
                    return;
                }
                // if (!this.formExport.product_id) {
                //     this.$Message.error("请选择产品");
                //     return;
                // }
                export_qrcode(this.formExport)
                    .then((res) => {
                        this.getList();
                        this.exportModal = false;
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
        },
        cancelImportCodeModal() {
            this.importCodeModal = false;
        },
        submitImportCodeModal() {
            if (
                !this.formImportCode.batch_id &&
                !this.formImportCode.product_id
            ) {
                this.$Message.error("请选择批次/产品");
                return;
            }
            if (!this.formImportCode.file) {
                this.$Message.error("请上传文件");
                return;
            }
            other_special_import(this.formImportCode)
                .then((res) => {
                    this.getList();
                    this.importCodeModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelModal() {
            this.modals = false;
        },
        submitModal() {
            if (this.modalID == 1) {
                let data = {
                    batch_id: this.formData.batch_id,
                    product_id: this.formData.product_id,
                    agent_id: this.formData.agent_id,
                    status: this.formData.status,
                    productive_time: this.formData.productive_time,
                    warranty_days: this.formData.warranty_days,
                    expiration_date: this.formData.expiration_date,
                    id: this.itemData.count_id,
                    able_key: this.formData.able_key,
                    qrcode_key: this.formData.qrcode_key,
                };
                qrcode_count_edit(data)
                    .then((res) => {
                        this.getList();
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            } else if (this.modalID == 2) {
                let data = {
                    id: this.itemData.id,
                    batch_id: this.formData.batch_id,
                    product_id: this.formData.product_id,
                    agent_id: this.formData.agent_id,
                    status: this.formData.status,
                    productive_time: this.formData.productive_time,
                    warranty_days: this.formData.warranty_days,
                    expiration_date: this.formData.expiration_date,
                };
                qrcode_edit(data)
                    .then((res) => {
                        this.getQrcodeList();
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
            this.modals = false;
        },
        goManage(row) {
            this.pageQrcode.count_id = row.id;
            this.pageQrcode.page = 1;
            this.pageQrcode.limit = 10;
            this.pageQrcode.start_date = "";
            this.pageQrcode.end_date = "";
            this.pageQrcode.qrcode_number = "";
            this.pageQrcode.delivery_qrcode = "";
            this.pageQrcode.status = "";
            this.getQrcodeList();
            setTimeout(() => {
                this.manageDrawer = true;
            }, 300);
        },
        goDrawer() {
            this.getExportList();
            setTimeout(() => {
                this.infoDrawer = true;
            }, 300);
        },
        goDownload(row) {
            window.open(row.show_path);
        },
        // 文件上传时
        handleProgress() {
            this.$Message.loading({
                content: "上传中...",
                duration: 0,
            });
        },
        exceededSize(e) {
            this.$Message.warning("文件大小限制在5MB以内");
        },
        // 文件上传类型错误
        handleFormatError() {
            this.$Message.destroy();
            this.$Message.warning("请上传xlsx格式");
        },
        keySuccess(e) {
            this.formImportCode.file = e.data.url;
            this.$Message.destroy();
            this.$Message.success(e.msg);
        },
        cancelProductModal() {
            this.productModal = false;
        },
        submitProductModal() {
            customer_sales_save(this.formProduct)
                .then((res) => {
                    this.productModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        changeActiveDate(e) {
            if (e) {
                this.formProduct.active_date = e;
            } else {
                this.formProduct.active_date = "";
            }
        },
        // 删除图片
        delImg(item, index) {
            item.show_upload.splice(index, 1);
            item.upload_value.splice(index, 1);
        },
        // 删除视频
        delVideo(item) {
            item.show_upload = "";
            item.upload_value = "";
        },
    },
};
</script>


<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.width_height_100 {
    width: 100%;
    height: 100%;
}
.width_height_30 {
    width: 30px;
    height: 30px;
}
.qrcode-date {
    display: block;
}
::v-deep .ivu-checkbox-wrapper-checked.ivu-checkbox-border {
    background: #53c41a;
    border-radius: 5px;
    font-size: 14px;
    color: #fff;
    border-color: #53c41a;
}
::v-deep .ivu-checkbox {
    display: none;
}
::v-deep .ivu-checkbox.ivu-checkbox-checked {
    display: none;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53c41a;
    border-color: #53c41a;
    box-shadow: -1px 0 0 0 #53c41a;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: var(--primary-color);
    background-color: var(--primary-color);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.width_height_18 {
    width: 18px;
    height: 18px;
}
.width_height_200 {
    width: 200px;
    height: 200px;
    border: 1px solid #9fa5bb;
}
.width_15 {
    width: 15vw;
}
.flex-column {
    flex-direction: column !important;
}
.product-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 15px;
    color: #484e66;
    margin-bottom: 10px;
}
.img-divs {
    background: #f1f5f8;
    border-radius: 4px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 12px 12px 0 12px;
}
.img-div {
    width: 70px;
    height: 70px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 0 12px 12px 0;
}
.img-div-icon {
    width: 25px;
}
.img-txt {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
}
.upload-div {
    position: relative;
    width: 70px;
    height: 70px;
    margin: 0 12px 12px 0;
}
.upload-del {
    position: absolute;
    top: -6px;
    right: -6px;
    cursor: pointer;
}
.upload-img {
    width: 70px;
    height: 70px;
    border-radius: 4px;
}
.cursor-p {
    cursor: pointer;
}
</style>